/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Информация о партнере и пункте отправления/получения
 */
export type OrderShortPoint = {
  /**
   * ФИО/наименование партнера (отправителя/получателя)
   */
  partnerName: string
  /**
   * Наименование терминала или адрес забора/доставки
   */
  pointName: string
  /**
   * Тип терминала или курьер (Terminal - обычный терминал, Pvz-Yarche - магазин Ярче, Courier - забор/доставка курьером по адресу)
   */
  pointType: OrderShortPoint.pointType
}
export namespace OrderShortPoint {
  /**
   * Тип терминала или курьер (Terminal - обычный терминал, Pvz-Yarche - магазин Ярче, Courier - забор/доставка курьером по адресу)
   */
  export enum pointType {
    TERMINAL = 'terminal',
    PVZ_YARCHE = 'pvz-yarche',
    COURIER = 'courier'
  }
}
